import { ref, watch, computed } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import store from '@/store'
import { getInvoices } from '@/composables/invoiceService'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useInvoicesList() {
  // Use toast
  const toast = useToast()

  const refInvoiceListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', label: '#', sortable: true },
    { key: 'customer_billing_full_name', label: i18n.t('Client'), sortable: true,  sort: (a, b) => a.localeCompare(b)},
    { key: 'amount', label: i18n.t('Amount'), sortable: true },
    { key: 'dates', label: i18n.t('Fechas'), sortable: true },
    { key: 'payment_method', label: i18n.t('Payment method'), sortable: true },
    { key: 'paid', label: i18n.t('Paid'), sortable: true },
    { key: 'actions', label: i18n.t('Actions') },
  ]
  const perPage = ref(10)
  const totalInvoices = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const typeFilter=ref(null)
  const paymentMethodFilter=ref(null)
  const groupFilter=ref(null)
  const startDateFilter=ref(null)
  const endDateFilter=ref(null)
  const accountFilter=ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refInvoiceListTable.value ? refInvoiceListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInvoices.value,
    }
  })

  const refetchData = () => {
    refInvoiceListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter, typeFilter, paymentMethodFilter, groupFilter, startDateFilter, endDateFilter, accountFilter], () => {
    refetchData()
  })

  // old
  // const fetchInvoices = (ctx, callback) => {
  //   store
  //     .dispatch('invoices/fetchInvoices', {
  //       q: searchQuery.value,
  //       perPage: perPage.value,
  //       page: currentPage.value,
  //       sortBy: sortBy.value,
  //       sortDesc: isSortDirDesc.value,
  //       status: statusFilter.value,
  //       type: typeFilter.value,
  //       paymentMethod: paymentMethodFilter.value, 
  //       group: groupFilter.value,
  //       start_date: startDateFilter.value,
  //       end_date: endDateFilter.value,
  //     })
  //     .then(response => {
  //       const { invoices, total } = response.data

  //       callback(invoices)
  //       totalInvoices.value = total
  //     })
  //     .catch(() => {
  //       toast({
  //         component: ToastificationContent,
  //         props: {
  //           title: "Error fetching Invoices list",
  //           icon: 'AlertTriangleIcon',
  //           variant: 'danger',
  //         },
  //       })
  //     })
  // }

  const fetchInvoices = async function () {
    let response = await getInvoices({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      status: statusFilter.value,
      type: typeFilter.value,
      paymentMethod: paymentMethodFilter.value, 
      group: groupFilter.value,
      start_date: startDateFilter.value,
      end_date: endDateFilter.value,
      account: accountFilter.value
    })
    const { invoices, total } = response.data
    totalInvoices.value = total
    return (invoices)
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveInvoiceStatusVariantAndIcon = function(statusData) {

    if (statusData.status==-1) return { variant: 'primary', icon: 'ArrowUpCircleIcon', label: statusData.label }
    if (statusData.status==0) return { variant: 'danger', icon: 'InfoIcon', label: statusData.label }
    if (statusData.status==1) return { variant: 'success', icon: 'CheckCircleIcon', label: statusData.label }
    if (statusData.status==2) return { variant: 'secondary', icon: 'AlertTriangleIcon', label: statusData.label }
    if (statusData.status==3) return { variant: 'warning', icon: 'ShuffleIcon', label: statusData.label }



    return { variant: 'secondary', icon: 'XIcon' }
  }

  const resolveClientAvatarVariant = function(amount, total_payments, status, isCorrective) {
    if (status == -1) return 'primary'

    if (amount == total_payments) return 'success'
    if (total_payments == 0) return 'danger'
    if (total_payments > 0 && total_payments < amount) return 'warning'

    return 'primary'
  }

  /**
   * Comprobar si es un pago parcial
   */
    const isPartialPaid = function(statusData){
      if( statusData.status==3) return {value: true , owe: statusData.owe}
      return {value: false}
  }

  return {
    fetchInvoices,
    tableColumns,
    perPage,
    currentPage,
    totalInvoices,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refInvoiceListTable,

    statusFilter,
    typeFilter,
    paymentMethodFilter,
    groupFilter,
    startDateFilter,
    endDateFilter,
    accountFilter,
    
    resolveInvoiceStatusVariantAndIcon,
    resolveClientAvatarVariant,
    isPartialPaid,
    refetchData,
  }
}
